module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-backward-324b15699634cab0df64df4a5163bcc8.png";